import { z } from "zod";

import { DateIsoString } from "@/core/types";

export const UpdateTimeReportProjectItemResult = z.object({
  itemId: z.number(),
  lastModificationDate: DateIsoString,
});

export type UpdateTimeReportProjectItemResult = z.infer<typeof UpdateTimeReportProjectItemResult>;
